"use strict";

import Swiper from "swiper";

document.addEventListener("DOMContentLoaded", () => {
    const mobileBreakpoint = window.matchMedia("(max-width: 768px)");

    document.querySelectorAll(".articles.page-builder").forEach((container) => {
        const sliderEl = container.querySelector(".articles.swiper");
        if (!sliderEl) return;

        let swiperInstance = null;

        function handleSwiper() {
            if (mobileBreakpoint.matches) {
                if (!swiperInstance) {
                    swiperInstance = new Swiper(sliderEl, {
                        slidesPerView: "auto",
                        spaceBetween: 20,
                        observer: true,
                        observeParents: true
                    });
                }
            } else {
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                    swiperInstance = null;
                }
            }
        }

        handleSwiper();

        mobileBreakpoint.addEventListener("change", handleSwiper);
    });
});